export type Permission = string;
